export default __webpack_public_path__ + "static/media/osceblogo.92fdaa77.png";